// ── V166: 매출 구분 — 음식 · 음료 · 주류 ─────────────────────────────────────────
// 사장님: "매출 입력할 때 주류&음료 매출과 음식 매출을 구분해야 할 것 같아. 주류&음료 입고도 나눠야 하고.
//          레시피 작성할 때 카테고리에 제조하는 음료, 제조하는 주류도 나눠야 함"
//   레시피(판매 메뉴)마다 구분: 음식 · 음료(에이드·커피 등 직접 만드는 것도) · 주류(하이볼·칵테일 등)
//   매출 거래에는 mix = { food, bev } (부가세 포함 금액, 합 = 그 거래 금액). bev = 음료 + 주류
//   손익: 음식 매출 vs 주류·음료 매출, 원가율은 식재료 입고 / 음식 매출, 주류·음료 입고 / 주류·음료 매출
import { normalizeMenuName } from './menuProfitability';

export const SALES_CLASSES = ['food', 'drink', 'alcohol'];
export const SALES_CLASS_LABEL = {
  food:    { ko: '음식', zh: '菜品', icon: '🍽️' },
  drink:   { ko: '음료', zh: '饮料', icon: '🥤' },
  alcohol: { ko: '주류', zh: '酒类', icon: '🍺' },
};
export const isSalesClass = (c) => SALES_CLASSES.includes(c);
export const isBevClass = (c) => c === 'drink' || c === 'alcohol';

const ALCOHOL_RE = /주류|칵테일|하이볼|맥주|소주|막걸리|와인|사케|위스키|보드카|酒|cocktail|beer|wine|bar\b/i;
const DRINK_RE = /음료|드링크|커피|주스|에이드|스무디|라떼|饮|咖啡|奶茶|果汁|drink|beverage|coffee|juice|ade\b/i;

/** 카테고리 이름으로 짐작 (레시피에 구분이 없을 때) */
export function guessClassFromCategory(name) {
  const s = String(name || '');
  if (ALCOHOL_RE.test(s)) return 'alcohol';
  if (DRINK_RE.test(s)) return 'drink';
  return 'food';
}

/** 판매 메뉴의 구분 — 레시피에 정한 것, 없으면 카테고리 이름으로 */
export const classOfMenu = (item, catName) => (isSalesClass(item && item.salesClass) ? item.salesClass : guessClassFromCategory(catName));

/** 메뉴 이름(정규화) → 구분 */
export function menuClassMap(categories = []) {
  const m = new Map();
  for (const c of categories || []) {
    for (const it of (c && c.items) || []) {
      if (!it || it.type !== 'menu' || !it.name) continue;
      m.set(normalizeMenuName(it.name), classOfMenu(it, c.name));
    }
  }
  return m;
}

const amtOf = (li) => {
  const q = Number(li && (li.qty ?? li.quantity)) || 0;
  return Number(li && (li.total ?? li.amount)) || q * (Number(li && li.unitPrice) || 0);
};
const clsOfLine = (li, classByNorm) => (isSalesClass(li && li.cls) ? li.cls : ((classByNorm && classByNorm.get(normalizeMenuName(li && (li.name || li.menuId)))) || 'food'));

/** 메뉴 줄들 → { food, drink, alcohol, bev } */
export function mixOfLineItems(lineItems = [], classByNorm) {
  const out = { food: 0, drink: 0, alcohol: 0 };
  for (const li of lineItems || []) out[clsOfLine(li, classByNorm)] += amtOf(li);
  out.bev = out.drink + out.alcohol;
  return out;
}

/** 금액 amt를 { food, bev } 비율로 나눈다 (합 = amt, 반올림 차이는 음식 쪽) */
export function splitMix(amt, food, bev) {
  const a = Number(amt) || 0;
  const t = (Number(food) || 0) + (Number(bev) || 0);
  if (!(t > 0)) return { food: a, bev: 0 };
  const b = Math.round((a * (Number(bev) || 0) / t) * 100) / 100;
  return { food: Math.round((a - b) * 100) / 100, bev: b };
}

/**
 * 그 달 매출의 음식 · 주류·음료 (부가세 포함, 거래장부 기준)
 *   거래에 mix가 있으면 그대로, 없으면 같은 날 메뉴 줄(lineItems)의 비율로, 그것도 없으면 '구분 없음'(음식으로 셈)
 * @returns { food, bev, unknown(구분 없는 금액, food에 포함), total }
 */
export function monthRevenueMix(transactions = [], month = '', classByNorm) {
  const incomes = (transactions || []).filter(t => t && t.type === 'income' && String(t.date || '').startsWith(month));
  const dayMix = new Map();
  for (const t of incomes) {
    if (!Array.isArray(t.lineItems) || !t.lineItems.length) continue;
    const m = mixOfLineItems(t.lineItems, classByNorm);
    const cur = dayMix.get(t.date) || { food: 0, bev: 0 };
    cur.food += m.food; cur.bev += m.bev;
    dayMix.set(t.date, cur);
  }
  let food = 0; let bev = 0; let unknown = 0;
  for (const t of incomes) {
    const amt = (Number(t.supply) || 0) + (Number(t.vat) || 0);
    if (t.mix && (Number(t.mix.food) || 0) + (Number(t.mix.bev) || 0) > 0) {
      const s = splitMix(amt, t.mix.food, t.mix.bev); food += s.food; bev += s.bev; continue;
    }
    const d = dayMix.get(t.date);
    if (d && d.food + d.bev > 0) { const s = splitMix(amt, d.food, d.bev); food += s.food; bev += s.bev; continue; }
    food += amt; unknown += amt;
  }
  const r = (n) => Math.round(n * 100) / 100;
  return { food: r(food), bev: r(bev), unknown: r(unknown), total: r(food + bev) };
}
